import {GeneralLedgerApiDto} from "../../api/model/rest";
import GeneralLedgerSummary from "./GeneralLedgerSummary";
import GeneralLedgerAccountSummary from "./GeneralLedgerAccountSummary";

export default class GeneralLedger {

	constructor(public readonly accountSummary: GeneralLedgerAccountSummary[],
		public readonly summary: GeneralLedgerSummary) {}

	static fromJson(json: GeneralLedgerApiDto): GeneralLedger {
		const accountSummary = json.accountSummary.map(GeneralLedgerAccountSummary.fromJson);
		const summary = GeneralLedgerSummary.fromJson(json.summary);
		return new GeneralLedger(accountSummary, summary);
	}
}
